module.exports = __webpack_public_path__ + "static/img/collage-title.a80df679.png";